<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0"
  >
    <div
      v-if="needRefresh"
      class="fixed inset-x-0 bottom-0 z-[100] p-4 pb-[max(1rem,env(safe-area-inset-bottom))] pointer-events-none"
      role="status"
      aria-live="polite"
    >
      <div
        class="pointer-events-auto mx-auto max-w-lg rounded-2xl border border-border-primary bg-bg-secondary shadow-2xl shadow-black/40 px-4 py-3.5 flex items-center gap-3"
      >
        <div
          class="flex-shrink-0 w-10 h-10 rounded-xl bg-accent-primary/15 text-accent-primary flex items-center justify-center"
          aria-hidden="true"
        >
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </div>

        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-text-primary">Update available</p>
          <p class="text-xs text-text-secondary mt-0.5">
            A newer version of AttTrack is ready. Reload to get the latest fixes.
          </p>
        </div>

        <div class="flex flex-shrink-0 items-center gap-2">
          <button
            type="button"
            class="text-xs font-medium text-text-secondary hover:text-text-primary px-2 py-2 rounded-lg transition-colors"
            :disabled="updating"
            @click="dismissUpdate"
          >
            Later
          </button>
          <button
            type="button"
            class="inline-flex items-center gap-1.5 rounded-xl bg-accent-primary hover:bg-accent-secondary text-white text-sm font-semibold px-3.5 py-2 transition-colors disabled:opacity-60"
            :disabled="updating"
            @click="applyUpdate"
          >
            <svg
              v-if="updating"
              class="w-4 h-4 animate-spin"
              fill="none"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            {{ updating ? 'Updating…' : 'Update' }}
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { usePwaUpdate } from '@/composables/usePwaUpdate'

const { needRefresh, updating, applyUpdate, dismissUpdate } = usePwaUpdate()
</script>
